import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FikoYTKokBilesenComponent } from '@/src/service/kok-bilesen/kok-bilesen.component';
import { paramDeger } from '@/src/app/shared/utils/param-deger.utils';

const DURUM_RENK: Record<string, string> = { 'Aktif': '#52c41a', 'Bakimda': '#ff9500', 'Arizali': '#ff4d4f' };

@Component({
  selector: 'makine-tanimi-kart-sade',
  standalone: true,
  imports: [CommonModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div class="ui text-center fluid pb-2">
      <div class="ui primary label mini"> Makine Tanımı </div>
    </div>
    <div class="sk" style="--sk-accent:#f5730a">
      <div class="sk-icerik">
        <div class="sk-baslik">{{ deger('makineAdi') || 'Isimsiz Makine' }}</div>
        <div class="sk-alt">{{ kodTip() }}</div>
        @if (deger('marka') || deger('model')) { <div class="sk-alt">{{ markaModel() }}</div> }
      </div>
      <div class="sk-sag">
        <span class="sk-chip" [style.border-color]="durumRenk()" [style.color]="durumRenk()">{{ deger('durum') || 'Aktif' }}</span>
      </div>
    </div>
  `,
})
export class MakineTanimiKartSadeComponent extends FikoYTKokBilesenComponent {
  parametreler = input<any>();
  constructor() { super(); }
  p = computed(() => this.parametreler()?.ek || {});
  deger(alan: string): any { return paramDeger(this.p(), alan); }
  kodTip = computed(() => [this.deger('makineKodu'), this.deger('makineTipi')].filter(v => !!v).join(' - ') || '-');
  markaModel = computed(() => [this.deger('marka'), this.deger('model')].filter(v => !!v).join(' '));
  durumRenk = computed(() => DURUM_RENK[this.deger('durum')] || '#52c41a');
}
